module.exports = __webpack_public_path__ + "img/FreelancerPeopleDesktop.3806f295.webp";